import { render, staticRenderFns } from "./moni.vue?vue&type=template&id=38891e0a&scoped=true&"
import script from "./moni.vue?vue&type=script&lang=js&"
export * from "./moni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38891e0a",
  null
  
)

export default component.exports